import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { ISaveInstruction } from 'pages/PageServiceDictionary/interfaces';

export const getInstructions = (data: IDynamicTableParams) => {
  return instance()
    .post('/serviceDictionary/list', data)
    .then((response) => response.data);
};

export const getAvailableColumns = () => {
  return instance()
    .post('/serviceDictionary/availableColumns')
    .then((response) => response.data);
};

export const getAvailableGroupColumns = () => {
  return instance()
    .post('/serviceDictionary/availableGroupColumns')
    .then((response) => response.data);
};

export const addNewInstruction = (instruction: ISaveInstruction) => {
  return instance()
    .post('/serviceDictionary/save', instruction)
    .then((response) => response.data);
};

export const updateInstruction = (instruction: ISaveInstruction) => {
  return instance()
    .post('/serviceDictionary/update', instruction)
    .then((response) => response.data);
};

export const deleteInstruction = (id: number) => {
  return instance()
    .post('/serviceDictionary/delete', { id })
    .then((response) => response.data);
};

export const getInstruction = (id: number) => {
  return instance()
    .post('/serviceDictionary/get', { id })
    .then((response) => response.data);
};
